import React, { useState, useMemo } from "react";
import OpenRequest from "./OpenRequest";
import AnsweredRequest from "./AnsweredRequest";
import { useUserStore } from "store/userStore";
const Request: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"open" | "answered">("open");

  const TabContent = useMemo(
    () => ({
      open: <OpenRequest />,
      answered: <AnsweredRequest />,
    }),
    []
  );
 const primaryAirlineCode = useUserStore((state) => state.primaryAirlineCode);

  return (
    <div className="">
      <section className="flex justify-between p-7 h-[125.5px] bg-cover">
        <p className="text-black text-lg font-semibold">Request - {primaryAirlineCode}</p>

        <nav className="flex items-center gap-2">
          <i className="st-home text-[#262626] text-xs" aria-hidden="true"></i>
          <a className="text-[#262626] text-sm font-extralight" href="/search">
            Home
          </a>
          <i
            className="st-arrow-right text-[#262626] text-xs"
            aria-hidden="true"
          ></i>
          <span className="text-[#262626] text-sm font-bold">Request - {primaryAirlineCode}</span>
        </nav>
      </section>

      <div className="-mt-16">
        <div className="px-6  w-full">
          <section className="bg-white rounded-lg mt-6 p-4">
            <div className="flex items-center gap-2 mx-auto my-4 p-2 bg-blue-50 rounded-full w-max">
              {(["open", "answered"] as const).map((tab) => (
                <button
                  key={tab}
                  className={`px-6 py-2 rounded-full text-sm font-medium ${
                    activeTab === tab
                      ? "bg-white text-[#FFD700]" // changed to yellow
                      : "text-lightgray-150"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div>
          </section>

          {TabContent[activeTab]}
        </div>
      </div>
    </div>
  );
};

export default Request;
